import { createFilterOptions } from '@mui/material';
import * as R from 'ramda';

import { SelectAutocomplete } from '@atom/mui';

const filterOptions = createFilterOptions<string>({
  matchFrom: 'any',
  limit: 250,
});

interface Props {
  id: string;
  value: any;
  onChange: (value: any) => void;
  options?: string[];
  disabled: boolean;
  error: boolean;
  dataCyPrefix: string;
}

const EnumSingleInput = ({
  id,
  value,
  onChange,
  options = [],
  disabled,
  dataCyPrefix,
  error,
}: Props) => {
  const handleChange = (event: any, option: string) => {
    const newValue = R.isNil(option) ? '' : option;
    onChange(newValue);
  };

  return (
    <SelectAutocomplete
      id={id}
      options={options}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      filterOptions={filterOptions}
      placeholder=""
      error={error}
      data-cy={`${dataCyPrefix}EnumSingleInput`}
    />
  );
};

export default EnumSingleInput;
